import { financeFetcher } from './fetcher';

export const createPayoutProfile = data => {
    return financeFetcher
        .post(`/payout_profiles/`, {
            data
        })
        .then(({ response }) => response);
};

export const updatePayoutProfile = (id, data) => {
    return financeFetcher.put(`/payout_profiles/${id}`, { data }).then(({ response }) => response);
};

export const deletePayoutProfile = id => {
    return financeFetcher.delete(`/payout_profiles/${id}`);
};
